module.exports = __webpack_public_path__ + "117296de0e8ce458684af5760803951c.jpg";